"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analysis = analysis;
exports.questions = void 0; // Root belief

var questions = [{
  prompt: "",
  extraText: "Write down a negative or unhelpful thought that you\u2019ve had recently. They may start with \u201CI am\u2026\u201D, \u201CI\u2019m not\u2026\u201D or it can be an unhelpful thought about a situation e.g. \u201CMy boss is upset with me\u201D. You can use one of the thoughts that you have previously identified in Retraining Thinking.",
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: 'What would be the worst thing that could happen if "__content__" was true?',
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: 'Now answer what would be the worst thing that could happen if "__content__" was true?',
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: 'Considering "__content__", what would be the worst thing that could happen if it was true?',
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: 'Finally write down what would be the worst thing that could happen if "__content__" was true?',
  placeholder: "",
  type: "multirow",
  aggregated: true,
  optional: false
}, {
  prompt: "",
  extraText: "You may have already uncovered your root fear by this point. You\u2019ll realise you\u2019ve reached the root when you\u2019ve uncovered an absolute statement that makes you feel anxious, afraid, sad or even angry. You may also be reluctant to write it down even though it\u2019s come up in your thoughts.\nRemember it\u2019s normal to feel these emotions when you\u2019ve uncovered a painful belief system that has been unhelpful. Uncovering your root fear helps you become more aware when these beliefs may be controlling parts of your life.\nMy root fear is:",
  placeholder: "",
  type: "multirow",
  aggregated: true,
  optional: false
}];
exports.questions = questions;

function analysis(answers) {
  return {
    answers: answers.slice(0, 5),
    rootThought: answers[5]
  };
}

;